
export const columns = [
  {
    Header: 'Information',
    accessor: 'name',
    minWidth: 300,
    maxWidth: 400,
  },
  {
    Header: 'Value',
    accessor: 'value',
  },
];

export default {
  columns,
};



// WEBPACK FOOTER //
// ./src/components/grids/PackagingInfoGrid/gridConfig.jsx